import React, { RefObject, useEffect } from "react";
import EditVideoPage from "../../../common/components/videoMenu/EditVideo";
import { Video } from "../../../common/video/models/Video";
// import VideoReactions from "../../../viewer/videoPlayer/components/player/reactions/VideoReactions";
import styles from "./VideoPlayerWithSubs.module.css";
import "./reactPdf.css";
import { ExtractExtention } from "../../../utils/ObjectUtils";
import { useInitText } from "../../../components/function/useInitText";
interface VideoPlayerWithSubsProps {
    video: Video;
    videoRef: RefObject<HTMLVideoElement>;
    currentVideoTimeMs: number;
    track: string;
    setEditModalOpen: (target: boolean) => void;
}

function VideoPlayerWithSubs({
    video,
    videoRef,
    currentVideoTimeMs,
    track,
    setEditModalOpen,
}: VideoPlayerWithSubsProps) {
    const token = localStorage.getItem("cineonhub_access_token");
    // ビデオURL
    const sourceUrl =
        process.env.REACT_APP_API_ENDPOINT +
        video.sourceUrl +
        "/" +
        ExtractExtention(video.fileName) +
        "?Authorization=" +
        token;

    // 動画再生するURL
    const [currentUrl, setCurrentUrl] = useInitText();

    // 再生表示パターン切り替え時に再生時間を保持する
    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.currentTime = Math.floor(currentVideoTimeMs / 1000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (currentUrl === "") {
            setCurrentUrl(sourceUrl);
        }
        // eslint-disable-next-line
    }, [sourceUrl]);

    if (!video) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <div className={styles.videoArea}>
                {/* ビデオ */}
                <video
                    id="videoPlayer"
                    className={
                        videoRef.current &&
                        videoRef.current.videoWidth / videoRef.current.videoHeight >= 1
                            ? styles.LandscapeVideo
                            : styles.PortraitVideo
                    }
                    controls
                    autoPlay
                    width="100%"
                    ref={videoRef}
                    key={currentUrl} // Needed to inform React of source changes.
                    controlsList="nodownload"
                    style={{ display: "block" }}
                >
                    <source src={currentUrl} type="video/mp4" />
                    <track default={true} kind="subtitles" srcLang="ja" label="オン" src={track} />
                </video>

                {/* /* ビデオリアクション
                <VideoReactions
                    reactions={video.reactions}
                    videoId={video.id}
                    videoDuration={video.durationMillis}
                    videoRef={videoRef}
                /> */}

                {/* ビデオ編集ボタン */}
                <div className={styles.editVideoIcon}>
                    <EditVideoPage videoId={video.id} setEditModalOpen={setEditModalOpen} />
                </div>
            </div>
        </>
    );
}

export default VideoPlayerWithSubs;
